import { PublicHeader } from '@/components/PublicHeader';
import { PublicFooter } from '@/components/PublicFooter';
import { Link } from 'react-router-dom';
import { Building2, Mail, Phone, MapPin } from 'lucide-react';

const ImpressumPage = () => {
  return (
    <div className="min-h-screen bg-background">
      <PublicHeader />

      {/* Content */}
      <main className="max-w-4xl mx-auto px-6 py-12">
        <article data-testid="impressum-content">
          {/* Title */}
          <div className="mb-8 pb-6 border-b border-border">
            <div className="flex items-center gap-3 mb-2">
              <Building2 className="w-8 h-8 text-primary" />
              <h1 className="text-3xl font-['Oswald'] font-bold tracking-wider uppercase m-0">
                Impressum
              </h1>
            </div>
            <p className="text-sm text-muted-foreground mt-2">
              Angaben gemäss Art. 3 Abs. 1 lit. s UWG (Schweiz)
            </p>
          </div>

          {/* Content */}
          <div className="space-y-8 text-foreground/90">
            {/* Betreiber */}
            <section>
              <h2 className="font-['Oswald'] text-xl font-bold uppercase tracking-wider mb-4 text-primary">
                Betreiber der Website
              </h2>
              <div className="bg-card border border-border p-6">
                <p className="font-bold text-lg mb-1">S.H.R.T.</p>
                <p className="text-muted-foreground mb-1">Swiss Historic Racing Team</p>
                <p className="text-sm text-muted-foreground mb-4">Verein gem&auml;ss Art. 60 ff. ZGB</p>
                
                <div className="space-y-3">
                  <div className="flex items-start gap-3">
                    <MapPin className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" />
                    <div>
                      <p className="font-medium">Kuno Schär</p>
                      <p>St. Niklausstrasse 1</p>
                      <p>CH-4502 Solothurn</p>
                      <p>Schweiz</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* Kontakt */}
            <section>
              <h2 className="font-['Oswald'] text-xl font-bold uppercase tracking-wider mb-4 text-primary">
                Kontakt
              </h2>
              <div className="bg-card border border-border p-6 space-y-4">
                <div className="flex items-center gap-3">
                  <Mail className="w-5 h-5 text-primary flex-shrink-0" />
                  <a 
                    href="mailto:info@kunoschaer.ch" 
                    className="text-primary hover:underline"
                  >
                    info@kunoschaer.ch
                  </a>
                </div>
                <div className="flex items-center gap-3">
                  <Phone className="w-5 h-5 text-primary flex-shrink-0" />
                  <a 
                    href="tel:+41794153031" 
                    className="text-primary hover:underline"
                  >
                    +41 79 415 30 31
                  </a>
                </div>
                <div className="pt-3 mt-3 border-t border-border">
                  <p className="text-sm text-muted-foreground mb-1">Technische Anliegen</p>
                  <div className="flex items-center gap-3">
                    <Mail className="w-5 h-5 text-primary flex-shrink-0" />
                    <div>
                      <span className="font-medium">Thomas Barth</span>{' · '}
                      <a href="mailto:barththomas@mac.com" className="text-primary hover:underline">barththomas@mac.com</a>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* Vertretungsberechtigte */}
            <section>
              <h2 className="font-['Oswald'] text-xl font-bold uppercase tracking-wider mb-4 text-primary">
                Vertretungsberechtigte Personen
              </h2>
              <div className="bg-card border border-border p-6">
                <p>Kuno Schär, Präsident</p>
                <p>Thomas Barth, Technik</p>
              </div>
            </section>

            {/* Haftungsausschluss */}
            <section>
              <h2 className="font-['Oswald'] text-xl font-bold uppercase tracking-wider mb-4">
                Haftungsausschluss
              </h2>
              <div className="prose prose-invert max-w-none">
                <p className="leading-relaxed">
                  Die Inhalte dieser Website wurden mit grösster Sorgfalt erstellt. Für die Richtigkeit, 
                  Vollständigkeit und Aktualität der Inhalte übernehmen wir jedoch keine Gewähr.
                </p>
              </div>
            </section>

            {/* Urheberrechte */}
            <section>
              <h2 className="font-['Oswald'] text-xl font-bold uppercase tracking-wider mb-4">
                Urheberrechte
              </h2>
              <div className="prose prose-invert max-w-none">
                <p className="leading-relaxed">
                  Die durch den Websitebetreiber erstellten Inhalte und Werke auf dieser Website unterliegen 
                  dem schweizerischen Urheberrecht. Beiträge Dritter sind als solche gekennzeichnet. Die 
                  Vervielfältigung, Bearbeitung und Verbreitung bedürfen der schriftlichen Zustimmung des 
                  jeweiligen Autors bzw. Erstellers.
                </p>
              </div>
            </section>

            {/* Datenschutz Hinweis */}
            <section>
              <h2 className="font-['Oswald'] text-xl font-bold uppercase tracking-wider mb-4">
                Datenschutz
              </h2>
              <div className="prose prose-invert max-w-none">
                <p className="leading-relaxed">
                  Die Nutzung unserer Website ist in der Regel ohne Angabe personenbezogener Daten möglich. 
                  Soweit auf unseren Seiten personenbezogene Daten (beispielsweise Name, Anschrift oder 
                  E-Mail-Adressen) erhoben werden, erfolgt dies stets auf freiwilliger Basis. Diese Daten 
                  werden ohne Ihre ausdrückliche Zustimmung nicht an Dritte weitergegeben.
                </p>
                <p className="leading-relaxed mt-4">
                  Wir weisen darauf hin, dass die Datenübertragung im Internet (z.B. bei der Kommunikation 
                  per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem 
                  Zugriff durch Dritte ist nicht möglich.
                </p>
              </div>
            </section>
          </div>
        </article>
      </main>

      <PublicFooter />
    </div>
  );
};

export default ImpressumPage;
